import { SvgIconDefinition } from '@am/icons-common-types';
const width = 100;
const height = 100;
const path = `
    M76.3,40.9c-1.2,0-2.1,0.9-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1
    C78.4,41.8,77.5,40.9,76.3,40.9z
    M74.6,22.6c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2V17h6.7c5.2,0,9.3,4.2,9.4,9.3v21.5c0,0.7,0.3,1.4,0.9,1.8
		c0.6,0.4,1.4,0.4,2,0c0.6-0.4,1-1.1,0.9-1.8V26.3c0-7.3-6-13.3-13.3-13.3h-6.7V7.4c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2V13H53.8V7.4
		c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2V13H29.2V7.4c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2V13h-6.6c-7.3,0-13.3,6-13.3,13.3v58.9
		c0,7.3,6,13.3,13.3,13.3h28.9c0.7,0,1.4-0.3,1.8-0.9c0.4-0.6,0.4-1.4,0-2c-0.4-0.6-1.1-1-1.8-0.9H18.8c-2.5,0-4.9-1-6.6-2.8
		c-1.8-1.8-2.7-4.2-2.7-6.6V26.3c0-5.2,4.2-9.3,9.4-9.3h6.5v5.6c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-5.6h20.6v5.6c0,1.1,0.9,2,2,2
    c1.1,0,2-0.9,2-2v-5.6h20.8V22.6z
    M77.7,56.9c-11.5,0-20.8,9.3-20.8,20.8s9.3,20.8,20.8,20.8c11.5,0,20.8-9.3,20.8-20.8
		C98.5,66.2,89.2,56.9,77.7,56.9z M84.2,93.4c-6.3,2.6-13.6,1.2-18.5-3.7c-4.9-4.8-6.3-12.1-3.7-18.5c2.6-6.3,8.8-10.5,15.7-10.5
    c9.4,0,16.9,7.6,17,16.9C94.7,84.6,90.5,90.7,84.2,93.4z
    M82.6,75.8H79V70c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v7.8c0,1.1,0.9,2,2,2h5.7c1.1,0,2-0.9,2-2
    C84.6,76.7,83.7,75.8,82.6,75.8z
    M58.2,43c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1c0-1.2-0.9-2.1-2.1-2.1C59.2,40.9,58.2,41.8,58.2,43z
    M43.7,57.6c-1.2,0-2.1,0.9-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1
    C45.8,58.5,44.8,57.6,43.7,57.6z
    M27.7,40.9c-1.2,0-2.1,0.9-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1
    C29.8,41.8,28.8,40.9,27.7,40.9z
    M27.7,57.6c-1.2,0-2.1,0.9-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1
    C29.8,58.5,28.8,57.6,27.7,57.6z
    M27.7,73.5c-1.2,0-2.1,0.9-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1
    C29.8,74.5,28.8,73.5,27.7,73.5z
    M43.7,73.5c-1.2,0-2.1,0.9-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1
    C45.8,74.5,44.8,73.5,43.7,73.5z
    M43.7,40.9c-1.2,0-2.1,0.9-2.1,2.1c0,1.2,0.9,2.1,2.1,2.1c1.2,0,2.1-0.9,2.1-2.1
    C45.8,41.8,44.8,40.9,43.7,40.9z
    `;
export const aciCalendarClock: SvgIconDefinition = {
  iconData: [height, width, path],
  iconName: 'calerdar-clock',
};
